const encyclopediaDetails = () =>
  import(
    /* webpackChunkName: "encyclopedia~encyclopediaDetails" */ 'page/platform/encyclopedia/encyclopediaDetails'
  )

let routes = [
  {
    path: '/encyclopediaDetails/:id',
    component: encyclopediaDetails,
    meta: {
      cache: false
    }
  }
]

export default routes
